module.exports = __webpack_public_path__ + "media/images/icon__ranking@3x-3e0c8a32717fa54640b9a3bc49a8715f.png";